import { ensureSignedIn, providerIsSignedIn } from "../auth/microsoftAuth";
import { MS365Document } from "../types/types";
import { normalizeTimelineData } from "./GraphTimelineNormalizer";

export const fetchCopilotData = async (
  search?: string,
  maxResults: number = 10
): Promise<MS365Document[]> => {
  try {
    console.log("fetchCopilotData: Starting fetch with params:", {
      search,
      maxResults,
    });

    const provider = await ensureSignedIn();
    console.log("fetchCopilotData: Provider state:", provider?.state);

    if (!provider || !providerIsSignedIn(provider.state)) {
      console.error(
        "fetchCopilotData: Provider not signed in, returning empty array"
      );
      return [];
    }

    if (!provider.graph?.client) {
      console.error("fetchCopilotData: Graph client not available on provider");
      return [];
    }

    const graphClient = provider.graph.client;
    console.log("fetchCopilotData: GraphClient obtained, starting API calls");

    const body = {
      queryString: search ?? "",
      dataSource: "oneDriveBusiness",
      resourceMetadata: [
        "Title",
        "Author",
        "FileExtension",
        "Filename",
        "FileType",
        "InformationProtectionLabelId",
        "LastModifiedTime",
        "ModifiedBy",
        "Path",
        "SiteID",
      ],
      maximumNumberOfResults: maxResults,
    };

    const res = await graphClient
      .api("/copilot/retrieval")
      .version("beta")
      .post(body)
      .catch(() => null);

    // Query OneDrive Business
    const oneDriveResults = res ?? [];

    // Query SharePoint
    const sharepointBody = {
      ...body,
      dataSource: "sharePoint",
    };

    const sharepointRes = await graphClient
      .api("/copilot/retrieval")
      .version("beta")
      .post(sharepointBody)
      .catch(() => null);

    const sharepointResults = sharepointRes ?? [];

    // Combine results
    const combinedHits = [
      ...(oneDriveResults.retrievalHits ?? []),
      ...(sharepointResults.retrievalHits ?? []),
    ];

    console.log("fetchCopilotData: Combined hits:", combinedHits.length);

    if (!res) {
      console.log(
        "fetchCopilotData: No results from API, returning empty array"
      );
      return [];
    }

    // The beta API shape can vary; try common containers
    const resultData =
      (res && (res.value || res.results || res.data)) ?? res ?? [];

    console.log("fetchCopilotData: Returning results");
    return null; //normalizeTimelineData([], [], [], [], resultData.retrievalHits as any[]);
  } catch (error) {
    console.error("fetchCopilotData: Error occurred:", error);
    return [];
  }
};
